import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router/router'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		authenticated: false,
		user: {
			keepLogged: false,
			token: undefined,
		},
		alertMessage: undefined,
		alertType: undefined,
		rules: {
			required: (v) => !!v || 'Requerido',
			min2: (v) => (!!v && v.length > 2) || 'Min 2 caracteres',
			max200: (v) => (!!v && v.length < 201) || 'Max 200 caracteres',
			cpf: (v) => (!!v && v.length == 14) || 'CPF incompleto',
			email: (v) => /.+@.+\..+/.test(v) || 'Digite um email válido',
			numero: (v) =>
				(!isNaN(v) && v >= 0 && v < 1000 && v % 1 === 0 && /^-?[0-9]+$/.test(v)) ||
				'Digite um número inteiro menor que mil',
		},
		XMLHttpRequest: true,
		dialogCurso: false,
		dialogAula: false,
		dialogMateria: false,
		dialogVideo: false,
		dialogPlayer: false,
		dialogAttachment: false,
		dialogProva: false,
		dialogProvaNota: false,
		dialogUser: false,
		dialogUserCursos: false,
		dialogCursoCertificado: false,
		dialogUserCursoAula: false,
		searchAula: false,
		searchUser: false,
		searchUserCursos: false,
		userPlayer: false,
	},

	mutations: {
		logInOut: (state, { user, authenticated }) => {
			state.user = user
			state.authenticated = authenticated
		},
		alert: (state, { alertMessage, alertType }) => {
			state.alertMessage = alertMessage
			state.alertType = alertType
		},
		user: (state, { value }) => {
			state.user = value
		},
		authenticated: (state, { value }) => {
			state.authenticated = value
		},
		XMLHttpRequest: (state, { value }) => {
			state.XMLHttpRequest = value
		},
		dialogCurso: (state, { value }) => {
			state.dialogCurso = value
		},
		dialogAula: (state, { value }) => {
			state.dialogAula = value
		},
		dialogMateria: (state, { value }) => {
			state.dialogMateria = value
		},
		dialogVideo: (state, { value }) => {
			state.dialogVideo = value
		},
		dialogPlayer: (state, { value }) => {
			state.dialogPlayer = value
		},
		dialogAttachment: (state, { value }) => {
			state.dialogAttachment = value
		},
		dialogProva: (state, { value }) => {
			state.dialogProva = value
		},
		dialogProvaNota: (state, { value }) => {
			state.dialogProvaNota = value
		},
		dialogUser: (state, { value }) => {
			state.dialogUser = value
		},
		dialogUserCursos: (state, { value }) => {
			state.dialogUserCursos = value
		},
		dialogCursoCertificado: (state, { value }) => {
			state.dialogCursoCertificado = value
		},
		dialogUserCursoAula: (state, { value }) => {
			state.dialogUserCursoAula = value
		},
		searchAula: (state, { value }) => {
			state.searchAula = value
		},
		searchUser: (state, { value }) => {
			state.searchUser = value
		},
		searchUserCursos: (state, { value }) => {
			state.searchUserCursos = value
		},
		userPlayer: (state, { value }) => {
			state.userPlayer = value
		},
	},

	actions: {
		logIn: ({ commit }, { user, authenticated }) => {
			commit('logInOut', {
				user: user,
				authenticated: authenticated,
			})
		},
		logOut: ({ commit }, { destination }) => {
			commit('logInOut', {
				user: {
					keepLogged: false,
					token: undefined,
				},
				authenticated: false,
			}),
				router.push({
					name: 'Login',
					query: { redirect: destination },
				})
		},
		alert: ({ commit }, { alertMessage, alertType }) => {
			commit('alert', {
				alertMessage: alertMessage,
				alertType: alertType,
			})
		},
		errorServer: ({ dispatch }, { data, destination }) => {
			if (data.error === 1) {
				dispatch('alert', {
					alertMessage: data.alertMessage,
					alertType: data.alertType,
				})
			} else if (data.error === 2) {
				dispatch('logOut', { destination: destination })
			}
		},
		authenticated: ({ commit }, { value }) => {
			commit('authenticated', {
				value: value,
			})
		},
		user: ({ commit }, { value }) => {
			commit('user', {
				value: value,
			})
		},
		XMLHttpRequest: ({ commit }, { value }) => {
			commit('XMLHttpRequest', {
				value: value,
			})
		},
		dialogCurso: ({ commit }, { value }) => {
			commit('dialogCurso', {
				value: value,
			})
		},
		dialogAula: ({ commit }, { value }) => {
			commit('dialogAula', {
				value: value,
			})
		},
		dialogMateria: ({ commit }, { value }) => {
			commit('dialogMateria', {
				value: value,
			})
		},
		dialogVideo: ({ commit }, { value }) => {
			commit('dialogVideo', {
				value: value,
			})
		},
		dialogPlayer: ({ commit }, { value }) => {
			commit('dialogPlayer', {
				value: value,
			})
		},
		dialogAttachment: ({ commit }, { value }) => {
			commit('dialogAttachment', {
				value: value,
			})
		},
		dialogProva: ({ commit }, { value }) => {
			commit('dialogProva', {
				value: value,
			})
		},
		dialogProvaNota: ({ commit }, { value }) => {
			commit('dialogProvaNota', {
				value: value,
			})
		},
		dialogUser: ({ commit }, { value }) => {
			commit('dialogUser', {
				value: value,
			})
		},
		dialogUserCursos: ({ commit }, { value }) => {
			commit('dialogUserCursos', {
				value: value,
			})
		},
		dialogCursoCertificado: ({ commit }, { value }) => {
			commit('dialogCursoCertificado', {
				value: value,
			})
		},
		dialogUserCursoAula: ({ commit }, { value }) => {
			commit('dialogUserCursoAula', {
				value: value,
			})
		},
		searchAula: ({ commit }, { value }) => {
			commit('searchAula', {
				value: value,
			})
		},
		searchUser: ({ commit }, { value }) => {
			commit('searchUser', {
				value: value,
			})
		},
		searchUserCursos: ({ commit }, { value }) => {
			commit('searchUserCursos', {
				value: value,
			})
		},
		userPlayer: ({ commit }, { value }) => {
			commit('userPlayer', {
				value: value,
			})
		},
	},

	getters: {
		isMobileDevice: () => {
			return (
				typeof window.orientation !== 'undefined' ||
				navigator.userAgent.indexOf('IEMobile') !== -1
			)
		},
	},
})
